import { TablePagination } from '@mui/material';
import { t } from '@lingui/core/macro';

interface PropsType {
  totalItems: number;
  page: number;
  pageSize: number;
  handleChangePage: (number) => void;
  handleChangePageSize: (number) => void;
}

const HistoryListPagination = ({
  totalItems,
  page,
  pageSize,
  handleChangePage,
  handleChangePageSize,
}: PropsType) => {
  return totalItems ? (
    <TablePagination width="100%" component="div" data-testid="History-pagination" rowsPerPageOptions={[5, 10, 15, 25, 50, 200]} colSpan={6} count={totalItems} rowsPerPage={pageSize} showFirstButton={true} showLastButton={true} page={page} onPageChange={(_, page) => {
        handleChangePage(page);
      }} onRowsPerPageChange={(e) => {
        handleChangePageSize(Number(e.target.value));
      }} slotProps={{ select: {
        inputProps: {
          'aria-label': t`rows per page`,
          'data-testid': 'History-pagination-rows-per-page',
        },
        native: true,
      } }}/>
  ) : (
    <></>
  );
};
export default HistoryListPagination;
